//export const GET_ALL_CLIENT = 'GET_ALL_CLIENT';
export const ADD_CLIENT_FAILURE = 'ADD_CLIENT_FAILURE';
export const ADD_CLIENT_SUCCESS = 'ADD_CLIENT_SUCCESS';
export const ADD_CLIENT_MESSAGE = 'ADD_CLIENT_MESSAGE';